"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _VideoModalModule = _interopRequireDefault(require("./VideoModal.module.css"));
var _modal = require("../assets/icons/modal");
var _reactDraggable = _interopRequireDefault(require("react-draggable"));
var _excluded = ["draggable", "url", "onCancel", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var VideoModal = function VideoModal(_ref) {
  var draggable = _ref.draggable,
    url = _ref.url,
    onCancel = _ref.onCancel,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var modalRef = (0, _react.useRef)();
  var DraggableModalDialog = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
      handle: '.modal-header',
      nodeRef: modalRef
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Dialog, _extends({
      ref: modalRef
    }, props)));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, _extends({
    onHide: onCancel,
    contentClassName: (0, _classnames.default)(_VideoModalModule.default.modal, draggable ? _VideoModalModule.default.draggable : null, className),
    animation: !draggable,
    dialogAs: draggable ? DraggableModalDialog : _reactBootstrap.Modal.Dialog
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: _VideoModalModule.default.header,
    style: {
      '--close': "url(".concat(_modal.ClosePrimary, ")")
    },
    closeButton: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Title, null, "\u10D5\u10D8\u10D3\u10D4\u10DD \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D0")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: _VideoModalModule.default.body
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    src: url,
    frameBorder: 0,
    allowFullScreen: true
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: _VideoModalModule.default.footer
  }));
};
exports.VideoModal = VideoModal;
VideoModal.propTypes = {
  show: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['sm', null, 'lg', 'xl']),
  draggable: _propTypes.default.bool,
  url: _propTypes.default.string,
  onCancel: _propTypes.default.func
};
VideoModal.defaultProps = {
  show: true,
  centered: true,
  size: 'lg',
  draggable: true,
  url: '//www.youtube.com/embed/p1yAi8xSxVY'
};